const UPDATE_USER_DATA = 'core/userData/UPDATE_USER_DATA';
const UPDATE_USER_DATA_COMPLETED = 'core/userData/UPDATE_USER_DATA_COMPLETED';
const UPDATE_USER_DATA_FAILED = 'core/userData/UPDATE_USER_DATA_FAILED';

const GET_USER_DATA = 'core/userData/GET_USER_DATA';
const GET_USER_DATA_COMPLETED = 'core/userData/GET_USER_DATA_COMPLETED';
const GET_USER_DATA_FAILED = 'core/userData/GET_USER_DATA_FAILED';

const RESET_USER_DATA = 'core/userData/RESET_USER_DATA';
const RESET_FETCH = 'core/userData/RESET_SUCCESS';

export {
  UPDATE_USER_DATA,
  UPDATE_USER_DATA_COMPLETED,
  UPDATE_USER_DATA_FAILED,
  GET_USER_DATA,
  GET_USER_DATA_COMPLETED,
  GET_USER_DATA_FAILED,
  RESET_USER_DATA,
  RESET_FETCH
};
